import { List, Map } from 'immutable';
import { useSelector } from 'react-redux';

/**
 * Energy dragged onto a Pokémon while its Undo waits (Undo/undoableMoves), shown attached to it meanwhile: the
 * attachment as the game will send it, or null. The Pokémon is `userId`'s, at `benchPosition` (null: the active one).
 */
export function usePendingAttach(userId, benchPosition = null) {
  const attach = useSelector((state) => (state.undo ? state.undo.attach : null));
  if (!attach || !attach.card || attach.userId !== userId || attach.benchPosition !== benchPosition) {
    return null;
  }
  return Map({
    id: 'pending',
    card: attach.card,
    provides: attach.card.get('energy_id'),
    count: attach.card.get('energy_provided') || 1,
  });
}

/** The Pokémon's energy with the pending one on the end. */
export const withPending = (energyAttachments, pending) => (pending
  ? (energyAttachments || List()).push(pending)
  : energyAttachments);

/** Which card in your hand is shown attached while its Undo waits (its place in the hand), or null. */
export const usePendingAttachFromHand = () => useSelector(
  (state) => (state.undo && state.undo.attach ? state.undo.attach.handPosition : null),
);
